import * as React from "react";

const SvgSnow = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="Snow_svg__a">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Snow_svg__b">
        <path d="M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Snow_svg__c">
        <path d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Snow_svg__d">
        <path d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Snow_svg__e">
        <path d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#Snow_svg__a)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.89 0 10.664 4.774 10.664 10.664S5.89 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.289 0-13.198-5.91-13.198-13.199S-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(473.696 377.985)"
        />
      </g>
    </g>
    <g
      clipPath="url(#Snow_svg__b)"
      style={{
        fill: "#d5eaf8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#d5eaf8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M467.474 394.556c-.054.001-.106.005-.16.005a8.289 8.289 0 0 1-8.287-8.288 8.288 8.288 0 0 1 8.287-8.288h20.6a6.696 6.696 0 0 1 0 13.392l-.069-.003c-.595 5.34-5.122 9.492-10.621 9.492a10.688 10.688 0 0 1-9.75-6.31"
          style={{
            fill: "#d5eaf8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#Snow_svg__c)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#Snow_svg__d)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#Snow_svg__e)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -566.869 559.651)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 0 105.85)"
      d="M0-79.388h72v72H0z"
    />
  </svg>
);

export default SvgSnow;
